module.exports = __webpack_public_path__ + "static/media/welcome-bg.1c501a7d.png";